<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>通用管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/dicDataList')">字典列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_body">
        <el-table
          :data="tableData"
          style="width: 100%"
          :height="tableHeight"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="infoName"
            label="名称"
          >
          </el-table-column>

          <el-table-column
            prop="infoName"
            label="释义"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.infoName == 'postMoney'">包邮金额（0代表不包邮）</span>
              <span v-if="scope.row.infoName == 'redRand'">红包随机金额</span>
              <span v-if="scope.row.infoName == 'serviceName'">客服微信号</span>
              <span v-if="scope.row.infoName == 'cashMoney'">最低提现金额</span>
              <span v-if="scope.row.infoName == 'complainTel'">投诉电话</span>
              <span v-if="scope.row.infoName == 'expireDat'">补货订单过期天数</span>
              <span v-if="scope.row.infoName == 'yearCheckMoney'">门店一年考核金额</span>
              <span v-if="scope.row.infoName == 'cashRate'">提现手续费利率</span>
              <span v-if="scope.row.infoName == 'vipYear'">vip年度考核</span>
              <span v-if="scope.row.infoName == 'highYear'">联盟店年度考核</span>
              <span v-if="scope.row.infoName == 'cityYear'">市代年度考核</span>
              <span v-if="scope.row.infoName == 'niceHighYear'">优秀联盟店年度考核</span>
              <span v-if="scope.row.infoName == 'provinceYear'">省代年度考核</span>

              <span v-if="scope.row.infoName == 'newCeoYear'">董事年度考核</span>
              <span v-if="scope.row.infoName == 'newProvinceYear'">合伙人年度考核</span>
              <span v-if="scope.row.infoName == 'showZhibo'">显示直播：1-显示，2：不显示</span>
              <span v-if="scope.row.infoName == 'newAreaYear'">区域总监年度考核</span>
              <span v-if="scope.row.infoName == 'isDelIos'">ios删除：1-开启，2-关闭</span>

              <span v-if="scope.row.infoName == 'ceoYear'">CEO年度考核</span>
              <span v-if="scope.row.infoName == 'inviteToBox'">邀请省代算多少业绩</span>
              <span v-if="scope.row.infoName == 'inviteToCeoBox'">邀请CEO算多少业绩</span>
              <span v-if="scope.row.infoName == 'topYear'">总经销商年度考核</span>
              <span v-if="scope.row.infoName == 'suCode'">束宣校验码</span>

              <span v-if="scope.row.infoName == 'cutNum'">限购数量</span>
              <span v-if="scope.row.infoName == 'isCut'">是否限购（1-是，2-不是）</span>

              <span v-if="scope.row.infoName == 'cTp'">CEO→→省</span>
              <span v-if="scope.row.infoName == 'cTc'">CEO→→CEO</span>
              <span v-if="scope.row.infoName == 'cUp'">CEO→省</span>
              <span v-if="scope.row.infoName == 'cUc'">CEO→CEO</span>
              <span v-if="scope.row.infoName == 'pTc'">省→→CEO</span>
              <span v-if="scope.row.infoName == 'pTp'">省→→省</span>
              <span v-if="scope.row.infoName == 'pUp'">省→省</span>
              <span v-if="scope.row.infoName == 'pUc'">省→CEO</span>
              <span v-if="scope.row.infoName == 'beginChange'">换货开始时间</span>
              <span v-if="scope.row.infoName == 'endChange'">换货结束时间</span>
              <span v-if="scope.row.infoName == 'roleChange'">不可换货角色</span>
              <span v-if="scope.row.infoName == 'transferLossAmount'">调货亏损金额</span>
              <span v-if="scope.row.infoName == 'transferFullAmount'">调货超出金额</span>
              <span v-if="scope.row.infoName == 'courseLastDate'">可退课程的天数</span>
              <span v-if="scope.row.infoName == 'quKNe'">区域总监季度考核比例</span>
              <span v-if="scope.row.infoName == 'quKya'">区域总监季度考核不达标释放金额比例</span>
              <span v-if="scope.row.infoName == 'cutM'">区域总监个人奖励百分比</span>
              <span v-if="scope.row.infoName == 'cutAppl'">区域总监投诉量限制提现</span>
              <span v-if="scope.row.infoName == 'execPrice'">董事升级金额</span>
              <span v-if="scope.row.infoName == 'execLim'">董事折扣</span>
              <span v-if="scope.row.infoName == 'execRiskLim'">城市加盟商保证金比例</span>
              <span v-if="scope.row.infoName == 'stepMoney'">阶梯金额</span>
              <span v-if="scope.row.infoName == 'stepWord'">城市加盟商规则</span>
              <span v-if="scope.row.infoName == 'dongOneRate'">执行董1返佣比例</span>
              <span v-if="scope.row.infoName == 'highExecLim'">执行董优惠折扣</span>
              <span v-if="scope.row.infoName == 'highExecPrice'">执行董升级金额</span>
              <span v-if="scope.row.infoName == 'goodContent'">商品内容分类</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="infoValue"
            label="数值"
          >
            <template slot-scope="scope">
              <el-input v-if="scope.row.infoName != 'beginChange' && scope.row.infoName != 'endChange' && scope.row.infoName != 'roleChange'"
                placeholder="请输入数字"
                v-model="scope.row.infoValue"
              >
              </el-input>
              <el-date-picker v-else-if="scope.row.infoName == 'beginChange' || scope.row.infoName == 'endChange'"
              v-model="scope.row.infoValue"
              type="date"
              placeholder="选择日期">
            </el-date-picker>

              <el-select v-else
              :multiple="true"
              v-model="scope.row.infoValue"
              clearable
            >
              <el-option
                label="康减系列VIP会员"
                value="-0.5"
              ></el-option>
              <el-option
                label="康减系列高级会员"
                value="-0.4"
              ></el-option>
              <el-option
                label="康减系列荣誉会员"
                value="-0.3"
              ></el-option>
              <el-option
                label="康减系列市代"
                value="1.1"
              ></el-option>
              <el-option
                label="康减系列省代"
                value="2.1"
              ></el-option>
              <el-option
                label="康减系列CEO"
                value="3.1"
              ></el-option>
              <el-option
                label="VIP门店"
                value="0.0"
              ></el-option>
              <el-option
                label="联盟店"
                value="1.0"
              ></el-option>
              <el-option
                label="优秀联盟店"
                value="1.05"
              ></el-option>
              <el-option
                label="市代"
                value="2.0"
              ></el-option>
              <el-option
                label="省代"
                value="3.0"
              ></el-option>
              <el-option
                label="CEO"
                value="4.0"
              ></el-option>
              <el-option
                label="总经销商"
                value="5.0"
              ></el-option>

              <el-option
                label="合伙人"
                value="2.2"
              ></el-option>
              <el-option
                label="董事"
                value="4.2"
              ></el-option>
                <el-option label="经销商" value="4.8"></el-option>
              <el-option
                label="区域总监"
                value="5.1"
              ></el-option>
              <el-option
                label="城市加盟商"
                value="5.2"
              ></el-option>
            </el-select>

            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="150px"
          >
            <template slot-scope="scope">
              <el-button
                v-if="hasPower('60041991')"
                type="text"
                size="small"
                @click.native.prevent="delGoods(scope.row, scope.$index)"
              >
                修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>

  </el-main>
</template>


<script>
import { dateFunc } from "../../dateFunc";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "dicDataList",
  created() {},

  data() {
    return {
      loading:false,
      tableHeight:null,
      tableData: []
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.handleSearch();
  },
  methods: {
    delGoods(row, index) {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token"),
        key: row.infoName,
        value: row.infoName == 'roleChange' ? row.infoValue.join(',') : row.infoValue
      };
      console.log(typeof row.infoValue)
      if (row.infoName == 'beginChange' || row.infoName == 'endChange')
      {
        if (typeof row.infoValue != 'string')
        {
          params.value = dateFunc.formatDate(row.infoValue, "yyyy-MM-dd")
        }
        else {
          params.value = row.infoValue.substring(0, 10);
        }
      }
      that.loading = true;
      API.up_dic_data(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "上传成功",
                duration: 1500
              });
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    handleSearch() {
      this.search();
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token")
      };
      that.loading = true;
      API.dic_data(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.tableData = result.result.list;
              for (var i=0; i<that.tableData.length; i++)
              {
                if (that.tableData[i].infoName == 'roleChange')
                {
                  if (that.tableData[i].infoValue && that.tableData[i].infoValue != null && that.tableData[i].infoValue != '')
                  {
                    that.tableData[i].infoValue = that.tableData[i].infoValue.split(',');
                    for (var z=0; z<that.tableData[i].infoValue.length; z++)
                    {
                      that.tableData[i].infoValue[z] = that.tableData[i].infoValue[z] + '';
                    }
                  } else {
                    that.tableData[i].infoValue = [];
                  }
                  
                }
              }
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/dicDataList.vue